/** 18px icon over a 12px/500 label — the dock's bar button (extracted 1:1
 *  from the /cv bottom bar's web BarButton). */
export function ActionDockButton({
  icon,
  label,
  labelColor,
  onPress,
}: {
  icon: React.ReactNode;
  label: string;
  labelColor: string;
  onPress: () => void;
}) {
  return (
    <button
      type="button"
      className="action-dock-bar-button"
      onClick={onPress}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        minWidth: 40,
        height: 42,
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: '0 8px',
        borderRadius: 12,
        transition:
          'background-color 150ms cubic-bezier(0.19, 1, 0.22, 1), transform 150ms cubic-bezier(0.19, 1, 0.22, 1)',
      }}
    >
      {icon}
      <span
        style={{
          fontSize: 12,
          fontWeight: 500,
          lineHeight: '20px',
          letterSpacing: 0,
          color: labelColor,
          fontFamily: 'inherit',
          textTransform: 'capitalize',
          whiteSpace: 'nowrap',
        }}
      >
        {label}
      </span>
    </button>
  );
}
